var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_webdesign",
    transform: "translate(-960 -1978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2370",
    "data-name": "Group 2370",
    transform: "translate(960 1978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2367",
    "data-name": "Group 2367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5328",
    "data-name": "Path 5328",
    d: "M40.5,81A40.5,40.5,0,1,1,81,40.5,40.546,40.546,0,0,1,40.5,81Zm0-76.14A35.64,35.64,0,1,0,76.14,40.5,35.68,35.68,0,0,0,40.5,4.86Z",
    fill: "#01358d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2369",
    "data-name": "Group 2369",
    transform: "translate(16.2 17.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5329",
    "data-name": "Path 5329",
    d: "M54.547,76a2.378,2.378,0,0,1-.932-1.55L53.3,72.432H43.232l-.317,2.018A2.372,2.372,0,0,1,41.985,76c-.842.62-1.506,1.152-.842,1.24.64.085,6.678.008,7.122,0,.446.008,6.482.085,7.122,0C56.051,77.153,55.387,76.621,54.547,76Z",
    transform: "translate(-23.966 -31.243)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2368",
    "data-name": "Group 2368",
    transform: "translate(12.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5330",
    "data-name": "Path 5330",
    d: "M35.851,55.757c2.69-.019,3.025-.668,3.9-3.369,1.617-4.261,8.9,1.115,4.385,2.982S33.161,55.776,35.851,55.757Z",
    transform: "translate(-35.217 -27.13)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5331",
    "data-name": "Path 5331",
    d: "M65.436,22.125c-1.3-1.051-3.467-.534-4.829,1.157l-13.8,19.6c-1.362,1.69-1.355,1.367-.051,2.418s.991,1.128,2.352-.563l16.222-17.65C66.695,25.4,66.741,23.177,65.436,22.125Zm-3.548,2.347a7.447,7.447,0,0,0-.874-.773A3.114,3.114,0,0,1,64,22.355C62.124,23.465,61.888,24.472,61.888,24.472Z",
    transform: "translate(-37.225 -21.581)",
    fill: "#f9556d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5332",
    "data-name": "Path 5332",
    d: "M66.656,30.432H60.589l-2.68,2.916h7.776V56.675H22.917V33.348H47.8l2.053-2.916H21.944A1.945,1.945,0,0,0,20,32.376V60.564a1.944,1.944,0,0,0,1.944,1.943H66.656A1.943,1.943,0,0,0,68.6,60.564V32.376A1.943,1.943,0,0,0,66.656,30.432Z",
    transform: "translate(-20 -23.263)",
    fill: "#f9556d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1599",
    "data-name": "Ellipse 1599",
    transform: "translate(1024 1990)",
    fill: "#f9556d",
    stroke: "#fff",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.72f2c51014fba9abd64642ee8ebd7eee.svg";
export { ForwardRef as ReactComponent };